/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Mingyue Liu",
  title: "I'm Mingyue",
  subTitle: emoji(
    "A passionate Full Stack Software Developer 🚀 having an experience of building Web applications with JavaScript / Reactjs / NestJS and some other cool libraries and frameworks."
  ),
  // resumeLink: "/random link", // Set to empty to hide the button
  // resumeLink: "https://drive.google.com/file/d/1ZliTmKVbThJ8W4KZb0OyBefOHvISsUDn/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/986913",
  linkedin: "https://www.linkedin.com/in/mingyue-liu-22b37612a/",
  gmail: "merylliu1994@gmail.com",
  medium: "https://medium.com/@Ming1994",
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  skills: [
    emoji(
      "⚡ Full-Stack Application Architecture: Architect and develop highly scalable, secure web applications using React, TypeScript, and NestJS"
    ),
    emoji(
      "⚡ Complex UI & State Management: Engineer high-performance user interfaces with advanced state orchestration (Redux, Zustand) for real-time, high-traffic systems"
    ),
    emoji(
      "⚡ DevOps & Cloud Infrastructure: Design fully automated CI/CD pipelines and manage containerized cloud deployments using Docker, Nginx, and AWS — with AI integration including Anthropic Claude Prompt Engineering, Streaming/SSE, and Vector DB/RAG"
    ),
    emoji(
      "⚡ Infrastructure as Code: Provision and manage scalable cloud infrastructure using Terraform and the full AWS ecosystem — ECS Fargate, RDS, ElastiCache, ALB, Route 53, ACM, S3, CloudFront, and ECR"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "Html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "Css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "Sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "TypeScript",
      fontAwesomeClassname: "fab fa-typescript"
    },
    {
      skillName: "Reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "Nestjs",
      fontAwesomeClassname: "fab fa-nest"
    },
    {
      skillName: "NPM",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "Webpack",
      fontAwesomeClassname: "fa-solid fa-file-zipper"
    },
    {
      skillName: "MySQL",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "Mongodb",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "Redis",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "AWS",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "Docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "Nginx",
      fontAwesomeClassname: "fab fa-nginx"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Lawrence Technological University",
      logo: require("./assets/images/ltu.png"),
      subHeader: "Master of Science in Electrical and Computer Engineering",
      duration: "Jan 2016 - May 2018",
      desc: "Participated in the research of vehicular ad hoc networks and published 2 papers.",
      descBullets: [
        "A Game Theory Based Approach for Power Efficient Vehicular Ad Hoc Networks",
        "An Adaptive Multimedia Signal Transmission Strategy in Cloud-Assisted Vehicular Networks"
      ]
    },
    {
      schoolName: "XI’AN JiaoTong University",
      logo: require("./assets/images/jiaoda.png"),
      subHeader: "Bachelor of Science in Electrical and Computer Engineering",
      duration: "September 2012 - May 2018"
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: false, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Engineer",
      company: "Walmart Inc",
      companylogo: require("./assets/images/walmartLogo.jpg"),
      date: "Aug 2021 – Present"
      // desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      // descBullets: [
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      // ]
    },
    {
      role: "Front-End Developer",
      company: "Apple Inc",
      companylogo: require("./assets/images/appleLogo.jpg"),
      date: "Feb 2019 – Jul 2021"
      // desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    },
    {
      role: "Web Developer Intern",
      company: "Municipal Advisory Council of Michigan",
      companylogo: require("./assets/images/macLogo.jpeg"),
      date: "Feb 2018 – Feb 2019"
      // ndesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: true, // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Projects",
  subtitle: "SOME COOL TOOLS I CREATED TO MAKE LIFE EASIER",
  projects: [
    {
      screenshot: require("./assets/images/whattoeat-screenshot.png"),
      screenshotLink: "https://mealdice.com/signup",
      projectName: "Meal Dice / What To Eat",
      projectDesc:
        "Picks your meals, grabs the ingredients—American and Chinese included. No more ‘what should I eat?’ ever again!",
      techStack: {
        featured: [
          "React",
          "NestJS",
          "Redis",
          "AWS",
          "Terraform",
          "Claude API"
        ],
        full: [
          {
            category: "Frontend",
            items: [
              "React 19",
              "TypeScript",
              "React Router 7",
              "Zustand",
              "Bootstrap 5",
              "S3 + CloudFront"
            ]
          },
          {
            category: "Backend",
            items: [
              "NestJS 11",
              "TypeORM",
              "MySQL 8.0",
              "ElastiCache Redis",
              "Anthropic Claude",
              "Passport.js",
              "Jest + Supertest"
            ]
          },
          {
            category: "DevOps",
            items: [
              "AWS ECS Fargate",
              "Docker",
              "GitHub Actions",
              "Terraform",
              "RDS",
              "Route 53",
              "ALB"
            ]
          }
        ]
      },
      footerLink: [
        {
          name: "Visit Website",
          url: "https://mealdice.com",
          icon: "fas fa-external-link-alt"
        },
        {
          name: "GitHub",
          url: "https://github.com/986913/WHATTOEAT",
          icon: "fab fa-github"
        }
      ]
    }
    // {
    //   image: require("./assets/images/animals.webp"),
    //   projectName: "AI项目-动物慈善"
    // },
    // {
    //   image: require("./assets/images/AI.jpg"),
    //   projectName: "AI Agent项目",
    //   projectDesc: "traditonal SDE + AI agent integration, AI 项目落地",
    //   footerLink: [
    //     {
    //       name: "参考小红书文章",
    //       url: "https://www.xiaohongshu.com/explore/68462913000000000303b1a6?xsec_token=ABv9eF1EVoGj23T4qTBmEtxjpjn2OHw7RCuboFZbTa2jo=&xsec_source=pc_collect"
    //     }
    //   ]
    // },
    // {
    //   image: require("./assets/images/pwa.png"),
    //   projectName: "PWA项目"
    // }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "AWS Certified Solutions Architect – Associate",
      subtitle: "",
      image: require("./assets/images/codeInLogo.webp"),
      imageAlt: "AWS Certified Solutions Architect Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        },
        {
          name: "Award Letter",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        },
        {
          name: "Google Code-in Blog",
          url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        }
      ]
    },
    {
      title: "Google UX certification program",
      subtitle: "",
      image: require("./assets/images/codeInLogo.webp"),
      imageAlt: "AWS Certified Solutions Architect Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        },
        {
          name: "Award Letter",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        },
        {
          name: "Google Code-in Blog",
          url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        }
      ]
    },
    {
      title: "PWA Web App Developer",
      subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      image: require("./assets/images/pwaLogo.webp"),
      imageAlt: "PWA Logo",
      footerLink: [
        {name: "Certification", url: ""},
        {
          name: "Final Project",
          url: "https://pakistan-olx-1.firebaseapp.com/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: true, // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://medium.com/@Ming1994/core-web-vitals-for-engineers-speed-interactivity-stability-e3d14d7d7a2d",
      title: "Core Web Vitals for Engineers: Speed, Interactivity, Stability",
      description: "Core Web Vitals Summary"
    },
    {
      url: "https://medium.com/@Ming1994/understanding-database-normalization-1nf-2nf-3nf-and-denormalization-with-typeorm-examples-da91cffa2ed1",
      title: "Database Normalization",
      description:
        "Understanding Database Normalization: 1NF, 2NF, 3NF, and Denormalization (with TypeORM Examples)"
    },
    {
      url: "https://medium.com/@Ming1994/mastering-permutations-combinations-with-backtracking-5c66a9b3ea88",
      title: "Mastering Permutations & Combinations with Backtracking",
      description:
        "Stay tuned for the LeetCode breakdowns — visuals, walkthroughs, and brain-friendly recursion demystified"
    },
    {
      url: "https://medium.com/@Ming1994/multi-environment-configurations-in-nestjs-from-dotenv-to-the-official-config-module-9803f7097111",
      title: "Multi-Environment Configurations in NestJS",
      description:
        "Multi-Environment Configurations in NestJS: From Dotenv to the Official Config Module"
    },
    {
      url: "https://medium.com/@Ming1994/express-middleware-explained-for-interviews-e10843f2237f",
      title: "Express Middleware Explained for Interviews",
      description: "Build It Yourself to Truly Understand It"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "248-688-1111",
  email_address: "merylliu1994@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
